import { Descriptions } from "antd";
import TimezoneConverter from "@components/timezone-converter";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

interface InvoiceTypeGeneralInformationProps {
  details: {
    id: string;
    name: string;
    description: string;
    priority: Number;
    isFallback: boolean;
    active: boolean;
    deleted: boolean;
    clientId: string;
    createdAt: Date;
    updatedAt: Date;
  };
}

const InvoiceTypeGeneralInformation = (
  props: InvoiceTypeGeneralInformationProps
) => {
  const { details } = props;
  const {
    description,
    priority,
    isFallback,
    active,
    deleted,
    clientId,
    createdAt,
    updatedAt,
  } = details;

  const renderCheckmark = (active: boolean) => {
    if (active) {
      return <CheckOutlined style={{ color: "var(--tertiary-color)" }} />;
    } else {
      return <CloseOutlined style={{ color: "var(--red)" }} />;
    }
  };

  return (
    <Descriptions
      bordered={true}
      column={2}
      size={"small"}
      contentStyle={{
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxWidth: "200px",
      }}
    >
      <Descriptions.Item label="priority">
        {priority.toString()}
      </Descriptions.Item>
      <Descriptions.Item label="Is Fallback?">
        {renderCheckmark(isFallback)}
      </Descriptions.Item>
      <Descriptions.Item label="Active">
        {renderCheckmark(active)}
      </Descriptions.Item>
      <Descriptions.Item label="Deleted">
        {renderCheckmark(deleted)}
      </Descriptions.Item>
      <Descriptions.Item label="Client Id">{clientId}</Descriptions.Item>
      <Descriptions.Item label="Create Date">
        <TimezoneConverter date={createdAt} />
      </Descriptions.Item>
      <Descriptions.Item label="Update Date">
        <TimezoneConverter date={updatedAt} />
      </Descriptions.Item>
      <Descriptions.Item label="Description">{description}</Descriptions.Item>
    </Descriptions>
  );
};

export default InvoiceTypeGeneralInformation;
